import axiosInstance from './axiosInstance';

export const getAboutData = async (lang = 'zh') => {
  const response = await axiosInstance.get('/about-settings', {
    params: { lang: lang }
  });
  return response.data;
};